// extracted by mini-css-extract-plugin
export default {"tag":"OvK04b","rounded":"xN6cBY","inner":"fRkHOM"};